import { FC } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import {
  MultiTagFilteringField,
  MultiTagFilteringFieldProps,
  takeNewMultiTagValues
} from 'jbc-front/components/SearchForm';
import { Row, Header, Body } from './AdditionalSearchField';

type MultiTagFilteringFieldRowProps = Omit<MultiTagFilteringFieldProps, 'input'> & {
  name: string;
};

export const MultiTagFilteringFieldRow: FC<MultiTagFilteringFieldRowProps> = ({
  name,
  header,
  list,
  takeNewValuesFunc = takeNewMultiTagValues,
  NameWrapper
}) => {
  const { control } = useFormContext();
  const field = useController({ name, control });
  return (
    <Row>
      <Header>{header}</Header>
      <Body>
        <MultiTagFilteringField
          input={{
            value: field.field.value,
            onChange: field.field.onChange,
            onBlur: field.field.onBlur
          }}
          header={header}
          list={list}
          takeNewValuesFunc={takeNewValuesFunc}
          NameWrapper={NameWrapper}
        />
      </Body>
    </Row>
  );
};
